import React, { Component } from 'react'
import { withRouter, Link } from 'react-router-dom'
import Social from '../social/social'
import Menu from '../menu/menu'
import { sendEvent } from '../../helpers/analytics'
import './header.css'


class Header extends Component {

  render() {
    const { location } = this.props
    return (
      <div className="header">
        <div className="logo">
          <a href="http://s7.ru?utm_source=lentaru&utm_medium=banner&utm_campaign=special_project" className="s7-link" target="_blank" rel="noopener noreferrer">
            <img src="/images/logo_s7.svg" alt="" className="logo--s7" onClick={() => sendEvent('main', 'click', 'logo-s7')} />
          </a>
          <a href="http://lenta.ru" target="_blank" className="lentaru-link">
            <img src="/images/logo_lenta.svg" alt="" className="logo--lenta"  onClick={() => sendEvent('main', 'click', 'logo-lenta')} />
          </a>
        </div>

        <Social />

        <Menu isArticle={location.pathname.includes("article")} location={location.pathname} />
      </div>
    )
  }
}

export default withRouter(Header)


// WEBPACK FOOTER //
// ./src/components/header/header.js